import React from 'react';
import { RenderRace } from './RenderUtils.js' ;


export const ResultList = ({races}) => {
    return(
      <>
      {races.map(race => RenderRace(race , true ) )} 
      </>
    );
}

export const StartList = ({races}) => {
    return(
      <>
      {races.map(race => RenderRace(race ) )} 
      </>
    );
}
